import { faEdit ,faEye ,faSquarePlus} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button } from "reactstrap";
import { getFromLocalStorage } from "../../hooks/useLocalStorage";

const GetButtons = (props) => {
  const { onClick, type, name: customName, color: customColor, iconClassName: customIcon,loading } = props;

  const getButtonType = () => {
    switch (type) {
      case "add":
        return {
          color: "primary",
          iconClassName: "fa fa-plus",
          name: customName || "Add New",
        };
      case "refresh":
        return {
          color: "info",
          iconClassName: "fa fa-refresh",
          name: customName || "Refresh",
        };
      case "search":
        return {
          color: "primary",
          iconClassName: "fa fa-search",
          name: "Search",
        };
      case "export":
        return {
          color: "success",
          iconClassName: "fa fa-download",
          // name: "Export",
          name: customName || "Export",
        };
      case "download":
        return {
          color: "primary",
          iconClassName: "fa fa-cloud-download",
          // name: "Export",
          name: customName || "Download",
        };
      case "cancel":
        return {
          color: "danger",
          iconClassName: null,
          name: "Cancel",
        };
      case "submit":
        return {
          color: "primary",
          iconClassName: null,
          name: customName || "Submit",
        };
      // case "footer":
      //   return {
      //     color: "primary",
      //     iconClassName: null,
      //     name: customName || "Submit",
      //   };
        case "schedule":
        return {
          color: "primary",
          iconClassName: "fa fa-edit",
          name: "Schedule",
        };
        case "delete":
        return {
          color: "danger",
          iconClassName: null,
          name: "Delete",
        };
      default:
        return {
          color: customColor || "primary",
          iconClassName: customIcon || null,
          name: customName || "Custom Button",
        };
    }
  };

  const { color: buttonColor, iconClassName: buttonIcon, name: buttonName } = getButtonType();

  return (
    <>
      <Button
        color={buttonColor}
        // size="sm"
        size={type === 'submit' || type === 'cancel' ? '' : 'sm'}
        className="btnCustom"
        onClick={onClick}
        type={type === "submit" ? "submit" : "button"}
        disabled={type === "submit" && props.isSubmitting || loading }
        variant="contained"
      >
        {buttonIcon && <i className={buttonIcon}></i>} {type === "submit" && props.isSubmitting ? 'Loading...' : loading ? "Downloading..." : buttonName}
      </Button>
    </>
  );
};

export default GetButtons;

export const AnotherExportedComponent = (props) => {
  // ... (implementation of the other component)
};

export const EditIcon = (props) => {
  const { onClick, editDisabled, title } = props ;
  const userId = getFromLocalStorage("user")?.user_id;

  return userId !== 111 &&(
    <FontAwesomeIcon
    icon={faEdit}
    onClick={editDisabled ? null : onClick}
    style={{
      cursor: editDisabled ? "not-allowed" : "pointer",
      color: editDisabled ? "#ccc" : "blue",
      marginLeft: 10,
    }}
    disabled={editDisabled}
    title={title}
  />
  )
 
  };

  export const AddIcon = (props) => {
    const { onClick, editDisabled, title } = props ;
    const userId = getFromLocalStorage("user")?.user_id;
  
    return userId !== 111 &&(
      <FontAwesomeIcon
      icon={faSquarePlus}
      onClick={editDisabled ? null : onClick}
      style={{
        cursor: editDisabled ? "not-allowed" : "pointer",
        color: editDisabled ? "#ccc" : "blue",
        marginLeft: 10,
      }}
      disabled={editDisabled}
      title={title}
    />
    )
   
    };


    export const ViewIcon = (props) => {
      const { onClick, editDisabled, title } = props ;
      const userId = getFromLocalStorage("user")?.user_id;
    
      return userId !== 111 &&(
        <FontAwesomeIcon
        icon={faEye}
        onClick={editDisabled ? null : onClick}
        style={{
          cursor: editDisabled ? "not-allowed" : "pointer",
          color: editDisabled ? "#ccc" : "blue",
          marginLeft: 10,
        }}
        disabled={editDisabled}
        title={title}
      />
      )
     
      };
